import { render, staticRenderFns } from "./regionSideView.vue?vue&type=template&id=6b44da55"
import script from "./regionSideView.vue?vue&type=script&lang=js"
export * from "./regionSideView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports